import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const levels = [
  {
    label: "已证实",
    icon: "ri-checkbox-circle-line",
    cls: "text-secondary-600",
    desc: "有明确发布主体与发布时间，内容可被第三方核验。",
  },
  {
    label: "待确认",
    icon: "ri-error-warning-line",
    cls: "text-accent-600",
    desc: "来源不明或存在矛盾，尚不足以作为结论传播。",
  },
  {
    label: "已被辟谣",
    icon: "ri-close-circle-line",
    cls: "text-primary-600",
    desc: "经时间戳或来源比对后，可判定其不成立。",
  },
];

export default function CategoryAndLevels() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <div className="mb-2 flex items-center gap-2">
              <span className="h-px w-6 bg-primary-500" aria-hidden="true"></span>
              <span className="text-xs font-medium tracking-widest text-primary-600">信息分级</span>
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              先给信息贴标签，再谈是非
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              争议事件里最容易出错的，是把传闻当成事实来引用。本站对每一条内容都标注可信等级，你可以据此决定要不要相信、要不要转发。
            </p>
            <ul className="mt-6 space-y-4">
              {levels.map((lv) => (
                <li key={lv.label} className="flex gap-3 rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 ${lv.cls}`}>
                    <i className={`${lv.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{lv.label}</span>
                    <span className="mt-1 block text-xs leading-relaxed text-foreground-600">{lv.desc}</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <div className="mb-2 flex items-center gap-2">
              <span className="h-px w-6 bg-accent-500" aria-hidden="true"></span>
              <span className="text-xs font-medium tracking-widest text-accent-700">四大栏目</span>
            </div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">按栏目查找，更快看懂</h2>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {categories.map((c) => (
                <Link
                  key={c.slug}
                  to={`/category/${c.slug}`}
                  className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <span className="mt-4 font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {c.name}
                  </span>
                  <span className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{c.desc}</span>
                  <span className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600">
                    进入栏目
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}